const vitalPointPage = `
{{#> hartford/NavLayout currentPage=currentPage Pages=Pages basePath=basePath logoUrl=project.values.logoUrl }}
  <div class="vital-point-page">
    <div class="container">
      <div class="vital-point-content">
        <h2 class="headline">{{project.values.vitalPointHeadline}}</h2>
        <pre class="vital-point-text">{{project.values.vitalPointText}}</pre>

        <div class="vital-point-video-container">
          <div class="video-wrapper">
            <video
              src="{{project.values.vitalPointVideoUrl}}"
              controls
              muted
              autoplay
              preload="metadata">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
{{/hartford/NavLayout}}
`;

const vitalPointPageStyles = `
  .vital-point-page {
    padding: 30px 0;
    background-color: #f8f9fa;
  }

  .container {
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
    padding: 0 15px;
  }

  .vital-point-content {
    max-width: 900px;
    margin: 0 auto;
  }

  .vital-point-content .headline {
    color: rgb(0, 82, 163);
    font-weight: bold;
    font-size: 32px;
    margin-top: 20px;
    margin-bottom: 30px;
  }

  .vital-point-text {
    font-family: 'Roboto', Arial, sans-serif;
    font-size: 18px;
    line-height: 1.8;
    color: #444;
    margin-bottom: 40px;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    max-width: 100%;
    overflow-x: auto;
  }

  .vital-point-video-container {
    margin-top: 40px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
  }

  .video-wrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    height: 0;
    overflow: hidden;
  }

  .video-wrapper video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    object-fit: cover;
    background-color: #000;
  }

  @media (max-width: 768px) {
    .vital-point-page {
      padding: 40px 0;
    }

    .headline {
      font-size: 28px;
      margin-bottom: 20px;
    }

    .vital-point-text {
      font-size: 16px;
      padding: 20px;
    }
  }

  @media (max-width: 576px) {
    .headline {
      font-size: 24px;
    }

    .vital-point-text {
      padding: 15px;
      line-height: 1.6;
    }
  }
`;

export const vitalPointBlocks: any[] = [
  {
    name: 'hartford/VitalPointPage',
    partial: vitalPointPage,
    css: vitalPointPageStyles,
  },
];
